var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "activity-log-wrapper"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Activity Task and Note Log")]), _vm._v(" "), _c('b-table', {
    ref: "table",
    staticClass: "activity-log-items",
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "id": "activity-log-items",
      "fields": _vm.fields,
      "items": _vm.logEntries
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "chemtracker-empty-text"
        }, [_vm._v("\n          No log items have been created yet.\n        ")])];
      }
    }, {
      key: "cell(action)",
      fn: function (row) {
        return [_c('b-link', {
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.removeLogEntry(row.item.id);
            }
          }
        }, [_vm._v(" Remove ")])];
      }
    }, {
      key: "cell(field_incident_invest_activity)",
      fn: function (row) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(row.item.field_incident_invest_activity)
          }
        })];
      }
    }])
  })], 1), _vm._v(" "), _c('b-button', {
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v(" Log Note or Task ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "add-log-activity-item",
      "centered": "",
      "scrollable": "",
      "title": "Log Note or Task",
      "size": "md",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "md-modal-body-padded"
  }, [_c('add-metadata-entity', {
    attrs: {
      "association-bundle": "incident_investigation",
      "association-uuid": _vm.uuid,
      "metadata-type": "incident_investigation_activity"
    },
    on: {
      "submit-form-data": function ($event) {
        return _vm.handleAddAction($event);
      }
    }
  })], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "scrollable": "",
      "id": "remove-log-item",
      "ok-title": "Confirm",
      "centered": "",
      "title": "Please confirm that you wish to remove this task/note."
    },
    on: {
      "ok": _vm.handleConfirmArchiveTaskNote
    }
  }, [_vm.currentTaskNote ? _c('div', {
    staticClass: "md-modal-body-padded"
  }, [_vm._v("\n      " + _vm._s(_vm.currentTaskNote.field_incident_invest_activity) + "\n    ")]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }